import Axios from 'api/client';
import { FilterGroupRequest } from 'components/filter/types';
import { TaskFilterRequest } from 'components/filter/types-legacy';
import { TaskFormLinkedResource } from 'components/tasks/types';
import { Task, TaskHistoryItem, TaskStatus } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface CreateTaskParams {
    title: string;
    description: string;
    due_at?: string | null;
    assigned_to?: number | null;
    status: TaskStatus;
    links: Omit<TaskFormLinkedResource, 'value'>[];
}

interface UpdateTaskParams extends Partial<CreateTaskParams> {
    archived?: boolean;
}
interface FetchTasksParams extends Omit<FilterParams, 'filters' | 'query'> {
    advancedQuery?: string;
    filters?: FilterGroupRequest<TaskFilterRequest>[];
}

interface FetchTaskHistoryParams {
    page?: number;
    limit?: number;
}

const fetchTasks = (accountId: number, params: FetchTasksParams) => {
    const { filters, ...rest } = params;
    return Axios.post<PaginatedData<Task>>(`/accounts/${accountId}/get_tasks`, {
        ...filters,
        ...rest,
    }).then(response => response.data);
};

const fetchTaskIds = (accountId: number, params: FetchTasksParams) => {
    const { filters, ...rest } = params;

    return Axios.post<number[]>(`/accounts/${accountId}/get_tasks`, {
        ...filters,
        ...rest,
        only: 'id',
    }).then(response => response.data);
};

const fetchTaskById = (accountId: number, taskId: number) =>
    Axios.get<Task>(`/accounts/${accountId}/tasks/${taskId}`).then(response => response.data);

const fetchTaskHistory = (accountId: number, taskId: number, params: FetchTaskHistoryParams) =>
    Axios.get<PaginatedData<TaskHistoryItem>>(`/accounts/${accountId}/tasks/${taskId}/history`, {
        params,
    }).then(response => response.data);

const createTask = (accountId: number, params: CreateTaskParams) =>
    Axios.post<Task>(`/accounts/${accountId}/tasks`, params).then(response => response.data);

const updateTask = (accountId: number, taskId: number, params: UpdateTaskParams) =>
    Axios.patch<Task>(`/accounts/${accountId}/tasks/${taskId}`, params).then(
        response => response.data,
    );

const starTask = (accountId: number, taskId: number) =>
    Axios.post<Task>(`/accounts/${accountId}/tasks/${taskId}/star`).then(response => response.data);

const unstarTask = (accountId: number, taskId: number) =>
    Axios.post<Task>(`/accounts/${accountId}/tasks/${taskId}/unstar`).then(
        response => response.data,
    );

const deleteTask = (accountId: number, taskId: number) =>
    Axios.delete(`/accounts/${accountId}/tasks/${taskId}`).then(response => response.data);

export {
    fetchTasks,
    fetchTaskIds,
    fetchTaskById,
    fetchTaskHistory,
    createTask,
    updateTask,
    starTask,
    unstarTask,
    deleteTask,
};
export type { CreateTaskParams, UpdateTaskParams, FetchTasksParams, FetchTaskHistoryParams };
